import React, { useContext } from "react";
import "../../styles/Stickbar.css";
import webicon from "../../assets/details/ic_webinars.svg";
import challgeicon from "../../assets/details/ic_challenges_1.svg";
import particon from "../../assets/details/ic_participate.svg";
import contacticon from "../../assets/details/ic_mail.svg";
import { LanguageContext } from "../../App";
import TEXT from "../../data/text";

const Stickbar = ({
  scrollTo,
  handleParticipate,
  contactId,
  status,
  webinarCheck,
  challengeCheck,
}) => {
  const { language } = useContext(LanguageContext);
  return (
    <nav className="stick-nav">
      <ul className="stick-list">
        {status === "ongoing" ? (
          <li>
            <a
              className="participate stick-item"
              onClick={(e) => handleParticipate(e)}
            >
              <div className="stick-icon">
                <img className="img-fluid stick-img" src={particon} />
              </div>
              <div className="stick-content">
                <span>{TEXT[language]["STICKBAR"]["0"]}</span>
              </div>
            </a>
          </li>
        ) : (
          ""
        )}
        {challengeCheck ? (
          <li>
            <a
              className="challenges stick-item"
              onClick={(e) => scrollTo(e, "gotoChallenges")}
            >
              <div className="stick-icon">
                <img className="img-fluid stick-img" src={challgeicon} />
              </div>
              <div className="stick-content">
                <span>{TEXT[language]["STICKBAR"]["1"]}</span>
              </div>
            </a>
          </li>
        ) : (
          ""
        )}
        {webinarCheck ? (
          <li>
            <a
              className="webinars stick-item"
              onClick={(e) => scrollTo(e, "gotoWebinars")}
            >
              <div className="stick-icon">
                <img className="img-fluid stick-img" src={webicon} />
              </div>
              <div className="stick-content">
                <span>{TEXT[language]["STICKBAR"]["2"]}</span>
              </div>
            </a>
          </li>
        ) : (
          ""
        )}

        <li>
          <a
            className="contact_us stick-item"
            href={`mailto:${
              contactId ? contactId : "tcs.sustainathon@tcs.com"
            }`}
            target="_blank"
          >
            <div className="stick-icon">
              <img className="img-fluid stick-img" src={contacticon} />
            </div>
            <div className="stick-content">
              <span>{TEXT[language]["STICKBAR"]["3"]}</span>
            </div>
          </a>
        </li>
      </ul>
    </nav>
  );
};

export default Stickbar;
